import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { SliceKeys, SnackbarKeys } from "@sso/constant";
import { RootState } from "@sso/store";
import { SnackbarState } from "@sso/types";

const initialState: SnackbarState = { type: SnackbarKeys.INFO, title: "", closed: true };

export const SnackbarSlice = createSlice({
  name: SliceKeys.SNACKBAR,
  initialState,
  reducers: {
    pushSnackbar: (snackbar, action: PayloadAction<SnackbarState>) => {
      snackbar.type = action.payload.type;
      snackbar.title = action.payload.title;
      snackbar.generate = Date.now();
      snackbar.closed = false;
    },
    detachedSnackbar: snackbar => {
      snackbar.closed = true;
    },
  },
});

export const { pushSnackbar, detachedSnackbar } = SnackbarSlice.actions;
export const selectSnackbar = (state: RootState) => state.snackbar;

export default SnackbarSlice.reducer;
